/* eslint-disable */
export const region10Barangays = [
    {
        CITY: 'ALORAN',
        BARANGAY: 'BALINTONGA',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'BANISILON',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'CALUBE',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'CAPUTOL',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'CASUSAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'CONAT',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'CULPAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'DALISAY',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'DULLAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'IBABAO',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'LABO',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'LAWA-AN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'LOBOGON',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MACUBON (SINA-AD)',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MAKAWA',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MANAMONG',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MATIPAZ',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MAULAR',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MITAZAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'MONTERICO',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'NABUNA',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'OSPITAL (POB.)',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'PALAYAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'PELONG',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'SINAMPONGAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'TAGUANAO',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'TAWI-TAWI',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'TORIL',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'TUBOD (JUAN BACAYO)',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'TUGAYA',
    },
    {
        CITY: 'ALORAN',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'LANDING',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'LUMIPAC',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'LUSOT',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'MISOM',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'MITACAS',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'NABUROS',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'NORTHERN POBLACION',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'PUNTA MIRAY',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'PUNTA SULONG',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'SINIAN',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'SOUTHERN POBLACION',
    },
    {
        CITY: 'BALIANGAO',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'BAG-ONG ANONANG',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'BAGUMBANG',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'BOLINSONG',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'BURACAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'CALOLOT',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'DEMETRIO FERNAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'DIGSON',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'DIMALCO',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'DULLAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'KANAOKANAO',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'LILOAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'LINCONAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'LODIONG',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'LOWER USUGAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'MAPUROG (MIGSALE)',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'MIGPANGE',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'MONTOL',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'PISA-AN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'POBLACION (CENTRO)',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'REMEDIOS',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'RUFINO LUMAPAS',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'SIBUYON',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'TANGAB',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'TIAMAN',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'TUSIK',
    },
    {
        CITY: 'BONIFACIO',
        BARANGAY: 'UPPER USOGAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'BUNAWAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'CALARAN',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'DAPACAN ALTO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'DAPACAN BAJO',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'DON BERNARDO NERI POB. (TRES DE MAYO)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'DON BERNARDO NERY POB. (TRES DE MAYO)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LANGUB',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAGCAMIGUING',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAMALAD',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'NORTHERN POBLACION',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SAN ISIDRO (SAN ISIDRO-SAN PEDRO)',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SILOY',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SINGALAT',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SOLINOG',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SOUTHWESTERN POBLACION',
    },
    {
        CITY: 'CALAMBA',
        BARANGAY: 'SULIPAT',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'BAGONG CLARIN',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'GANDAWAN',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'LAKE DUMINAGAT',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'LALUD',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'LAMPASAN',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'LIBORON',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'MARAMARA',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'NAPANGAN',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'NUEVA VISTA (MASAWAN)',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'PETIANAN',
    },
    {
        CITY: 'DON-VICTORIANO-CHIONGBIAN',
        BARANGAY: 'TUNO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'ADORABLE',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'BUTUAY',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'CORRALES',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'DICOLOC',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'GATA',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'GUINTOMOYAN',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'MACABAYAO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'MALIBACSAN',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'MATUGAS ALTO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'MATUGAS BAJO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'MIALEM',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'NACIONAL (POB.)',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'NAGA (POB.)',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'PALILAN',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'SETI',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'SIBAROC',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'SINARA ALTO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'SINARA BAJO',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'TABO-O',
    },
    {
        CITY: 'JIMENEZ',
        BARANGAY: 'TARAKA (POB.)',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'DALACON',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'DAMPALAN',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'DON ANDRES SORIANO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'EASTERN POBLACION',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'ESTANTE',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'JASA-AN',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'KATIPA',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'LUZARAN',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MABAS',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MACALIBRE ALTO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MACALIBRE BAJO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MANGUEHAN',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MANSABAY ALTO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MANSABAY BAJO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MOLATUHAN ALTO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'MOLATUHAN BAJO',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'PENIEL',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'PUNTOD',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'SIBUGON',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'SIBULA',
    },
    {
        CITY: 'LOPEZ-JAENA',
        BARANGAY: 'WESTERN POBLACION',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BERNAD',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BITO-ON',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CANIBUNGAN DAKU',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CANIBUNGAN PUTOL',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CANIPACAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'DALINGAP',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'GATA DAKU',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'GATA DIOT',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'GUBA (OZAMIS)',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'KINANGAY NORTE',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'KINANGAY SUR',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'LAPASAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'LUPAGAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'MALIBANGCAO',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'MASABUD',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'MIALEN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'PAN-AY',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'PENACIO',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'SEBASI',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'SEGATIC DAKU',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'SEGATIC DIOT',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'TINACLA-AN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BAGONG NAYON',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CAPULE',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'GUIBAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'LAYA-AN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'LINGATONGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MALIGUBAAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MANTUKOY',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MARUGANG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'NEW CASUL',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'POGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SMALL POTONGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SOSO-ON',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'UPPER DAPITAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'UPPER DIOYO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'UPPER POTONGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'UPPER SALIMPONO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'VIRAYAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'AGUNOD',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'BUENA VOLUNTAD',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CALACA-AN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CARTAGENA PROPER',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CATARMAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CEBULIN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'CLARIN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'DEBOLOC',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'EASTERN LOOC',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'ILISAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'LAO PROPER',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'LAO SANTA CRUZ',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'LOOC PROPER',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'MAMANGA DAKU',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'MAMANGA GAMAY',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'MANGIDKID',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'NEW CARTAGENA',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'NEW LOOK',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'NORTHERN POBLACION',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'PANALSALAN',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'PUNTOD',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SOUTHERN LOOC',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'SOUTHERN POBLACION',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'TIPOLO',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'UNIDOS',
    },
    {
        CITY: 'PLARIDEL',
        BARANGAY: 'USOCAN',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'BALON',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'BARRA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'BASIRANG',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'BONGABONG',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CABOL-ANONAN',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CAHAYAG',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CALAMBUTAN BAJO',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CALAMBUTAN SETTLEMENT',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CAMATING',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CANIBUNGAN PROPER',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CASILAK SAN AGUSTIN',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CENTRO HULPA (POB.)',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CENTRO NAPU (POB.)',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CENTRO UPPER (POB.)',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'DUANGUICAN',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'GALA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'GUMBIL',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'LOCSO-ON',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'MAIKAY',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'MARIBOJOC',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'MITUGAS',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'NAILON',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'NAMUT',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'NAPUROG',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'PAN-AY DIOT',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SEBAC',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SILONGON',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SINUZA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'TAGUIMA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'TIGDOK',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'YAHONG',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'APIL',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'BOLIBOL',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'BUNTAWAN',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'CANUBAY',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'CIRIACO C. PASTRANO (NILABO)',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'CLARIN SETTLEMENT',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'DOLIPOS ALTO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'DOLIPOS BAJO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'DULAPO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'DULLAN NORTE',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'DULLAN SUR',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LAMAC LOWER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LAMAC UPPER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LANGCANGAN LOWER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LANGCANGAN PROPER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LANGCANGAN UPPER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LAYAWAN',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LOBOC LOWER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'LOBOC UPPER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'MALINDANG',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'MIALEN',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'MOBOD',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'PAYPAYAN',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'PINES',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'RIZAL LOWER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'RIZAL UPPER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'SAN VICENTE ALTO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'SAN VICENTE BAJO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'SEBUCAL',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'SENOTE',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TABOC NORTE',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TABOC SUR',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TALAIRON',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TALIC',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TIPAN',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TOLIYOK',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TUYABANG ALTO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TUYABANG BAJO',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'TUYABANG PROPER',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'OROQUIETA',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: '50TH DISTRICT (POB.)',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'AGUADA (POB.)',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BAGAKAY',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BANADERO (POB.)',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BAYBAY SAN ROQUE',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BAYBAY SANTA CRUZ',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BAYBAY TRIUNFO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CALABAYAN',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CAPUCAO C.',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CAPUCAO P.',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CARANGAN',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CARMEN (MISAMIS ANNEX)',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CATADMAN-MANABAY',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'CAVINTE',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'DALAPANG',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'DIGUAN',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'DIMALUNA',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'DONA CONSUELO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'EMBARGO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'GALA',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'GANGO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'GOTOKAN DAKU',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'GOTOKAN DIOT',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'GUIMAD',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'GUINGONA',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'KINUMAN NORTE',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'KINUMAN SUR',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'LABINAY',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'LABO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'LAM-AN',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'LIPOSONG',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'LITAPAN',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'MALAUBANG',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'MANAKA',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'MANINGCOL',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'MENTERING',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'MOLICAY',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'PULOT',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'SANGAY DAKU',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'SANGAY DIOT',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'SINUZA',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'STIMSON ABORDO (MONTOL)',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'TABID',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'OZAMIS',
        BARANGAY: 'TRIGOS',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'BAGA',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'BANGKO',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'CAMANUCAN',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'LUTAO',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'MAP-AN',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'SALIMPUNO',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'SUMASAP',
    },
    {
        CITY: 'PANA-ON',
        BARANGAY: 'VILLALIN',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'AGAPITO YAP',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'AGAPITO YAP SR. (NAPILAN)',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'BITIBUT',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'BOUNDARY',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'CALUYA',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'CAPUNDAG',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'CASUL',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'DALUMPINAS',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'DASA',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'DIOYO',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'DISOY',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'EL PARAISO',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'GUINABOT',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'LOCUS',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'MACABIBO',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'MANLA',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'MASUBONG',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'MEDALLO',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SALIMPUNO',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SAPANG AMA',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SINAAD',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SIPAC',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SIXTO VELEZ',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'SIXTO VELEZ SR.',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'UPPER BAUTISTA',
    },
    {
        CITY: 'SAPANG-DALAGA',
        BARANGAY: 'VENTURA',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'CAGAY-ANON',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'CAMANSE',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'COLUPAN ALTO',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'COLUPAN BAJO',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'DINAS',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'LIBERTAD ALTO',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'LIBERTAD BAJO',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'SAN ISIDRO ALTO',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'SAN ISIDRO BAJO',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'SAN LORENZO RUIZ (SUNGAN)',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'SENOR',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'SINONOC',
    },
    {
        CITY: 'SINACABAN',
        BARANGAY: 'TIPAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'AQUINO (MARCOS)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BALATACAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BALUK',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BANGLAY',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY I - CITY HALL (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY II - MARILOU ANNEX (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY III- MARKET KALUBIAN (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY IV - ST. MICHAEL (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY V - MALUBOG (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY VI - LOWER POLAO (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BARANGAY VII - UPPER POLAO (POB.)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BINTANA',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BOCATOR',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'BONGABONG',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'CANIANGAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'CAPALARAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'CATAGAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'GARANG',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'GUINABOT',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'GUINALABAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'HUYOHOY',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'ISIDRO D. TAN (DIMALOC-OC)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'KIMAT',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'LABUYO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'LORENZO TAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'LUMBAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MALORO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MANTIC',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MAQUILAO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MATUGNAW',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MIGCANAWAY',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'MINSUBONG',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'OWAYAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'PAITON',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'PANALSALAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'PANGABUAN',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'PRENZA',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SALIMPUNO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SAN APOLINARIO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SANTA MARIA (BAGA)',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SICOT',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SILANGA',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SILANGIT',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SIMASAY',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'SUMIRAP',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'TAGUITE',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'TITURON',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'TANGUB',
        BARANGAY: 'VILLABA',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'BALINTAD',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'DANATAG',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'IMBATUG (POB.)',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'LACOLAC',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'LANGAON',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'LIBORAN',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'LINGATING',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'NICDAO',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'PUALAS',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'SALIMBALAN',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BAUNGON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'KALINGKING',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'KIABO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'MINDAGAT',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'OMAGLING',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'PATPAT',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAMPIANO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SILO-O',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SUMALSAG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CEBOLE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'C-HANDUMANAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DELAPA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DUMALAMA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KIBURIAO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'KIPAYPAYON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LINABO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LIPA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LUMINTAO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MANUTO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MERANGERANG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MIBANTANG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MINONGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MINSALIRAK',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MINSAMONGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PALACAPAO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PINILAYAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'POBLACION (KIOKONG)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PUNTIAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SALAWAGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BONACAO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BULALANG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CABULING',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CAYAGA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DURIAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'HALAPITAN (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'IGLUGSAD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'KALAGANGAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'KAWAYAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'KIBONGCOG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LITTLE BAGUIO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAGKALUNGAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MALAYANAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MATUPE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NACABUKLAD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NAMNAM',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PALACPACAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SACRAMENTO VALLEY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TUGOP',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'ANLOGAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'CABULOHAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'CANANGAAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'CAPINONAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'DALACUTAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'FREEDOM',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'IMBATUG',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'JASAAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'LAMBANGAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'MANDAHIKAN',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'MANDAING',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'PARADISE',
    },
    {
        CITY: 'CABANGLASAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'ALUDAS',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'ANGGA-AN',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'KINAPAT',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'KIRAON',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'KITINGTING',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'LAGANDANG',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'MACAPARI',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'MAICAN',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'MIGCAWAYAN',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'NEW COMPOSTELA',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'OLD DAMULOG',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'OMONAY',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'POBLACION (NEW DAMULOG)',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'POCOPOCO',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'SAMPAGAR',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DAMULOG',
        BARANGAY: 'TANGKULAN (JOSE RIZAL)',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'BARONGCOT',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'BUGWAK',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'DOLOROSA',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'KAPALARAN',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'KIANGGAT',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'MIARAY',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'MIGCUYA',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'SAGBAYAN',
    },
    {
        CITY: 'DANGCAGAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'BISMARTZ',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'BOCBOC',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'BUYOT',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'CALAOCALAO',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'DON CARLOS NORTE',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'DON CARLOS SUR (POB.)',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'EMBAYAO',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'KALUBIHON',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'KASIGKOT',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'KAWILIHAN',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'KIARA',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'KIBATANG',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'MANLAMONAY',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'MARAYMARAY',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'MINSALAGAN',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'NEW NONGNONGAN (MASIMAG)',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'OLD NONGNONGAN',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'PINAMALOY',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'PUALAS',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'SAN ANTONIO EAST',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'SAN ANTONIO WEST',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'SAN NICOLAS (BANBAN)',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DON-CARLOS',
        BARANGAY: 'SINANGGUYAN',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'BONTONGON',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'BULONAY',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'CAPITAN BAYONG',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'DUMALAGUING',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'GUIHEAN',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'HAGPA',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'IMPALUTAO',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'KALABUGAO',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'KIBENTON',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'IMPASUG-ONG',
        BARANGAY: 'SAYAWAN',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'BAGONGBAYAN',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'BAGOR',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'BALAORO',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'BAROY',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'HUSAYAN',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'KIBALAGON',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'KIBOGTOK',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'PAY-AS',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'PINAMANGUHAN',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'KADINGILAN',
        BARANGAY: 'SIBONGA',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'BABORAWON',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'CANITUAN',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'KIBANING',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'KINURA',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'LAMPANUSAN',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'MACA-OPAO',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'NINOY AQUINO',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'PAMOTOLON (PAMOTDON)',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'PUBLIC',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'SAN VICENTE FERRER',
    },
    {
        CITY: 'KALILANGAN',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'BUKANG LIWAYWAY',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'CAGAWASAN',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'EAST KIBAWE (POB.)',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'GUTAPOL',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'KIORAO',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'KISAWA',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'LABUAGON',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'MARAPANGI',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'MASCARINAS',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'NATULONGAN',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'NEW KIDAPAWAN',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'OLD KIBAWE',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'PALMA',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'PINAMULA',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'ROMAGOOC',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'SANIPON',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'SPRING',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'TALAHIRON',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'TUMARAS',
    },
    {
        CITY: 'KIBAWE',
        BARANGAY: 'WEST KIBAWE (POB.)',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'BALANGIGAY',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'BALUKBUKAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'BERSHIBA',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'BINOONGAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'BOBONG',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'BOLOCAON',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'CABALANTIAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'CALAPATON',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'DIGONGAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'EAST DALURONG',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KAHUSAYAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KALUMIHAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KAUYONAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KIMOLONG',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KIPILAS',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KITAIHON',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KITOBO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'KIULOM',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'MALOBALO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'METEBAGAO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'NAPALICO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'PAGAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'PANGANAN',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'SAGUNDANON',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'SINAYSAYAN (DALURONG)',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'SINUDA (SIMOD)',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'TANDONG',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'TAWAS',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'WEST DALURONG',
    },
    {
        CITY: 'KITAOTAO',
        BARANGAY: 'WHITE KULAMAN',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'ALANIB',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'BACLAYON',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'BALILA',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'BANTUANON',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'BUGCAON',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'CAPITAN JUAN',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'KA-ATOAN (KAATUAN)',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'KIBANGAY',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'KULASIHAN',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'SONGCO',
    },
    {
        CITY: 'LANTAPAN',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'CAPIHAN',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'CROSSING',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'GANGO',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'KILIOG',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'KINAWE',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'LATURAN',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'MAAMBONG',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'PALABUCAN',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'PONGOL',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'LIBONA',
        BARANGAY: 'SIL-IPON',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'AGLAYAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'APO MACOTE',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BANGCUD',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'BUSDI',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'CABURACANAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'CANAYAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'CAPITAN ANGEL',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'CASISANG',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'DALWANGAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'IMBAYAO',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'INDALAZA',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'KABALABAG',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'KALASUNGAY',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'KULAMAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'LAGUITAS',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'LINABO',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MANAGOK',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MANALOG',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MAPAYAG',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MAPULO',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'MIGLAMIN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'PATPAT (LAPU-LAPU)',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SAINT PETER',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SILAE',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SIMAYA',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SINANGLANAN',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'SUMPONG',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'VIOLETA',
    },
    {
        CITY: 'MALAYBALAY',
        BARANGAY: 'ZAMBOANGUITA',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'AGUSAN CANYON',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'ALAE',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'DAHILAYAN',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'DALIRIG',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'DAMILAG',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'DICLUM',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'GUILANG-GUILANG',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'KALUGMANAN',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'LINDABAN',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'LINGION',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'LUNOCAN',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'MALUKO',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'MAMBATANGAN',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'MAMPAYAG',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'MANTIBUGAO',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'MINSURO',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'SANKANAN',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'TANKULAN (POB.)',
    },
    {
        CITY: 'MANOLO-FORTICH',
        BARANGAY: 'TICALA',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'ANAHAWON',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'BAGONGSILANG',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'BASE CAMP',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'BAYABASON (SPRING)',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'CAMP I',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'COLAMBUGAN',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'DAGUMBA-AN',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'DANGGAWAN',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'DOLOGON',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'KIHARONG',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'KISANDAY',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'KUYA',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'LA ROXAS',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'PANADTALAN',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'PANALSALAN',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'MARAMAG',
        BARANGAY: 'TUBIGON',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'ADTUYON',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'BACUSANON',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'BANGAHAN',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'BARANDIAS',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'GANDINGAN',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'KIMANAIT',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'KIPADUKAN',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'LANGCATAON',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'LANTAY',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'MALIPAYON',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'MENDIS',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'NABALIWA',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'NEW EDEN',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'PAYAD',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'PIGTAURANAN',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PANGANTUCAN',
        BARANGAY: 'PORTULIN',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'CULASI',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'KISOLON',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'LICOAN',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'LUPIAGAN',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'OCASION',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'PUNTIAN',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SUMILAO',
        BARANGAY: 'VISTA VILLA',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'BAYLANAN',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'CACAON',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'COLAWINGON',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'COSINA',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'DAGUMBAAN',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'DAGUNDALAHON',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'DOMINOROG',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'INDULANG',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'LANTUD',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'LAPOK',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'LIGURON',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'LINGI-ON',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'LIRONGAN',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'MIARAYON',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SAGARAN',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SALUCOT',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SANTO NINO (LUMBAYAWA)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'SANTO NIÑO (LUMBAYAWA)',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'TAGBAK',
    },
    {
        CITY: 'TALAKAG',
        BARANGAY: 'TIKALAAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BAGONTAAS',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BANLAG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BAROBO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CATUMBALON',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'COLONIA',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'DAGAT-KIDAVAO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'GUINOYURAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'KAHAPUNAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LALIGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LILINGAYON',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LUMBO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LUROGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MAAPAG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MAILAG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MT. NEBO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'NABAGO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'PINATILAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SINABUAGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SINAYAWAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'TONGANTONGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'TUGAYA',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'VINTAR',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'ALGA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'BURA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CATIBAC',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'COMPOL',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'LILOAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MANDUAO',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'PANGHIAWAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'TANGARO',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'BUTAY',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'CABUAN',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'CANTAAN',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'MAAC',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'GUINSILIBAN',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'BENONI',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'BINATUBO (BINALIWAN)',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'CATOHUGAN',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'HUBANGON',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'OWAKAN',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'PUNTOD',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'MAHINOG',
        BARANGAY: 'TUPSAN PEQUENO',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'AGOHO',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'ANITO',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'BALBAGON',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'BAYLAO',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'BENHAAN',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'BUG-ONG',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'KUGUITA',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'MAGTING',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'NAASAG',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'SORO-SORO',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'TAGDO',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'TUPSAN',
    },
    {
        CITY: 'MAMBAJAO',
        BARANGAY: 'YUMBING',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'ALANGILAN',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BACNIT',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BUGANG',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'CUNA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'MANUYOG',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'MAYANA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BABALAYA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BABALAYAN TOWNSITE',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BINUNI',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'DELABAYAN WEST',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'DEMOLOGAN',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'DIMARAO',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'KAHAYAG',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'LIANGAN EAST',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'MATI',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'MINAULON',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'POBLACION BACOLOD',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'PUNOD (MALIWANAG)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'RUPAGAN',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'ABAGA',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'ADAPUN-ALI (DARIAT)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'ANGANDOG (BULAO)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'ANGAYEN (BALUT)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'BANGKO',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'BATOLACONGAN (BASAGAD)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'LANDA (GADONGAN)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'MAMAANUN',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'MARIA-CRISTINA',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'PACALUNDO',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'SANDOR (DADUAN)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'SANGCAD (CORMATAN )',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'SARIP-ALAWI (PAYAWAN)',
    },
    {
        CITY: 'BALOI',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'ANDIL',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'BAGONG DAWIS',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'BAROY DAKU',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'CABASAGAN',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'LIMWAG',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'LINDONGAN',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'MANAN-AO',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'PANGE',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'PRINCESA',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'RAWAN POINT',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'SAGADAN (SAGADAN LOWER)',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'SAGADAN UPPER',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'TINUBDAN',
    },
    {
        CITY: 'BAROY',
        BARANGAY: 'VILLAGE',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'ABUNO',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'ACMAC',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'BONBONON',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'BUNAWAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'BURU-UN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'DALIPUGA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'DIGKILAAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'DITUCALAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'DULAG',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'HINAPLANON',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'HINDANG',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'KABACSANAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'KIWALAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'LANIPAO',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'LUINAB',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'MAHAYHAY',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'MANDULOG',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'MARIA CRISTINA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'PANOROGANAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'PUGA-AN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'ROGONGON',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SARAY-TIBANGA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'SUAREZ',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'TAMBACAN',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'TIBANGA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'TIPANOY',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'TOMINOBO PROPER',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'TOMINOBO UPPER',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'UBALDO LAYA',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'UPPER HINAPLANON',
    },
    {
        CITY: 'ILIGAN',
        BARANGAY: 'VILLA VERDE',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'BARA-ASON',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'CAYONTOR',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'DELABAYAN',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'INUDARAN',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'KAWIT OCCIDENTAL',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'KAWIT ORIENTAL',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'PAITON',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'TACUB',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'TINGINTINGIN',
    },
    {
        CITY: 'KAUSWAGAN',
        BARANGAY: 'TUGAR',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'AUSTIN HEIGHTS',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'CAROMATAN',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'INUDARAN',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'KULASIHAN',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'MUKAS',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'MUNTAY',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'PAGALUNGAN',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'REBUCON',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'SIMBUCO',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'SMALL BANISILAN',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'SUCODAN',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'TABIGUE',
    },
    {
        CITY: 'KOLAMBUGAN',
        BARANGAY: 'TITUNOD',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'ABAGA',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'ANDIL',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'CABASAGAN',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'CAMALAN',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'DARUMAWANG BUCANA',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'DARUMAWANG ILAYA',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'EL SALVADOR',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'GUMAGAMOT',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'LALA PROPER (POB.)',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'LANIPAO',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'MAGPATAO',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'MARANDING',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'MATAMPAY BUCANA',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'MATAMPAY ILAYA',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'PACITA',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'PENDOLONAN',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'PINOYAK',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'RAW-AN',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'REBE',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'SAN ISIDRO LOWER',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'SAN ISIDRO UPPER',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'SANTA CRUZ LOWER',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'SANTA CRUZ UPPER',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'SIMPAK',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'TENAZAS',
    },
    {
        CITY: 'LALA',
        BARANGAY: 'TUNA-AN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BAGONG BADIAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BANSARVIL',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BELIS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'BUTADON',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'CATHEDRAL FALLS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'CURVADA',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'DE ASIS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'DONGGOAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'DURANO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'KAHAYAGAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'KIDALOS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'LA LIBERTAD',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'LAPINIG',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'MALINAS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'MARANDING',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'MARGOS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'PULANG YUTA',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'SUSO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'TAGUITIC',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'TIACONGAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'TIPOLO',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'TULATULAHAN',
    },
    {
        CITY: 'KAPATAGAN',
        BARANGAY: 'WATERFALLS',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BABASALON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BAGUIGUICON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'DAAN CAMPO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'DURIANON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LAMIGADATO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LEMONCRET',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LOWER CANINGAG (PERIMBANGAN)',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LUMBAC',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MALABAOGAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'OLANGO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'PANGAO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'PELINGKINGAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'POBLACION (BAGO-A-INGUD)',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'RARAB',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SOMIORANG',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TALAMBO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TAMBACON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TAWINIAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TIPAAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TOMBADOR',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'UPPER CANINGAG (TAGUITINGAN)',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'DALAMAS',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'DARIMBANG',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'DIMAYON',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'INAGONGAN',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'KIAZAR (POB.)',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'MALIMBATO',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'PANALAWAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'BARAKANAS',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'BARIS (LUMANGCULOB)',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'CAMP V',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'CANDIS',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'CANIOGAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'KAKAI RENABOR',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'LICAPAO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'MALINGAO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'PATUDAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'PIGCARANGAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'PINPIN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'PUALAS',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'TADEN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'TAGURANAO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'TANGUEGUIRON',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'TUBARAN',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'BUSQUE',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'LARAPAN',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'MAGOONG',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'PURAKAN',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'ROBOCON',
    },
    {
        CITY: 'LINAMON',
        BARANGAY: 'SAMBURON',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'BALAGATASA',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'CAMP 1',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'CLARO M. RECTO',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'INOMA',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'KULASIHAN (VILLANUEVA)',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'LABUAY',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'LIANGAN WEST',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'MENTRING',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAIGO',
        BARANGAY: 'SOGAPOD',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'BATAL',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'BUBONG RADAPAN',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'PASAYANON',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'POBLACION (MATUNGAO)',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'PUNTOD',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MATUNGAO',
        BARANGAY: 'SOMIORANG',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'BALABACUN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'BALINTAD',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'KADAYONAN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'LINDONGAN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'LINGCO-AN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'LININDING',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'LUMBA-BAYABAO',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'MAGANDING',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'NORTH CADULAWAN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'OLD POBLACION',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'PANGGAO',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'PANTAO-A-MUNAI',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'PINDOLONAN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'RAMAIN',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'SANDIGAMUNAI',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'TAGORANAO',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'TAMPARAN (MANDAYA)',
    },
    {
        CITY: 'MUNAI',
        BARANGAY: 'TAPOROG',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'ABAGA',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'CABASARAN (LAYA)',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'CANIBONGAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'DIMAYON',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'INAYAWAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'KALUDAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'KARCUM',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'KATUBUAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'LIANGAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'LUPITAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'MALAIG',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'MANGAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'MASIBAY',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'NOTONGAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'PANGANAPAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'PANTAR',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'PARIDI',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'PETADUN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'POBLACION (NUNUNGAN PROPER)',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'RARAB',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'RARABAN',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'REBUCON',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'SONGGOD',
    },
    {
        CITY: 'NUNUNGAN',
        BARANGAY: 'TARAKA',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'ALOON',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'BANDAY',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'BOBONGA PANTAO RAGAT',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'BOBONGA RADAPAN',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'CABASAGAN',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'CALAWE',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'CULUBUN',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'DILIMBAYAN',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'DIMAYON',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'LOMIDONG',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'MATAMPAY',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'NATANGCOPAN',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'PANSOR',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'PANTAO MARUG',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'TANGCAL',
    },
    {
        CITY: 'PANTAO-RAGAT',
        BARANGAY: 'TONGCOPAN',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'BANGCAL',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'BOWI',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'BUBONG MADAYA',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'CAMPONG',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'DIBAROSAN',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'KALANGANAN EAST',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'KALANGANAN LOWER',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'LUMBA-PUNOD',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'PANTAO-MARUG',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'PANTAO-RANAO',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'PANTAR EAST',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'PITUBO',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'POONA-PUNOD',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'PUNOD',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'SUNDIGA-PUNOD',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'TAWANAN',
    },
    {
        CITY: 'PANTAR',
        BARANGAY: 'WEST PANTAR',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'ALOWIN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'BUBONG-DINAIG',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'CABASARAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'CADAYONAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'CAROMATAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'DARAMBA',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'DINAIG',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'KABLANGAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'LININDINGAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'LUMBATAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'LUPITAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'MADAMBA',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'NUNANG',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'NUNUNGAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'PANTAO RAYA',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'PANTAON',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'PENDOLONAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'PENED',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'PIANGAMANGAAN',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'POBLACION (LUMBACAINGUD)',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'SULO',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'TAGORANAO',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'TANGCLAO',
    },
    {
        CITY: 'POONA-PIAGAPO',
        BARANGAY: 'TIMBANGALAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'BARANDIA',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'BULACON',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'BUNTONG',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'CALIMODAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'CAMP III',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'CURVA-MIAGAO',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'DALIGDIGAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'INASAGAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'KILALA',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'MABATAO',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'MADAYA',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'MAMAANON',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'MAPANTAO',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'MINDALANO',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PADIANAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PAGALONGAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PAGAYAWAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PANALIWAD-ON',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PANGANTAPAN',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PANSOR',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PATIDON',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'PAWAK',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'SAUMAY',
    },
    {
        CITY: 'SALVADOR',
        BARANGAY: 'SUDLON',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'BANING',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'BURIASAN (POB.)',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'DANSALAN',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'GAMAL',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'INUDARAN I',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'INUDARAN II',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'KARKUM',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'MABUGNAO',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'MAITO SALUG',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'MALA SALUG',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'MAMA-ANON',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'MAPUROG',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'PANCILAN',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'PANOLOON',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'SAPAD',
        BARANGAY: 'SAPAD',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'BANGAAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'BANSARVIL II',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'BAUYAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'CABONGBONGAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'CALIBAO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'CALIPAPA',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'CALUBE',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'CAMPO ISLAM',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'CAPOCAO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'DABLISTON',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'DANGULAAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'DITAGO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'KIRAPAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'KOREO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'MAGUINDANAO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'MAMAGUM',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'MINA',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'PANDANAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'PAYONG',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'PIKALAWAG',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'PIKINIT',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'PIRAKA',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'RAMAIN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'REBUCON',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'TAGULO',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'TANTAON',
    },
    {
        CITY: 'SULTAN-NAGA-DIMAPORO',
        BARANGAY: 'TOPOCON (CAPOCGO)',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'BAYABAO',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'BERWAR',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'BIG BANISILON',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'BIG MELADOC',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'BUBONG',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'LAMAOSA',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'LINDONGAN',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'LINGCO-AN',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'PAPAN',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'PELINGKINGAN',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'POONA KAPATAGAN',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'PUNOD',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'SMALL BANISILON',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'SMALL MELADOC',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'SOMIORANG',
    },
    {
        CITY: 'TANGCAL',
        BARANGAY: 'TANGCAL PROPER',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'BENIGWAYAN',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'CALATCAT',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'LAGTANG',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'LOGUILO',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'LUMBO',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'MOLOCBOLOC',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'SAMPATULOG',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'SUNGAY',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'TALABA',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'TAPARAK',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'TUGASNON',
    },
    {
        CITY: 'ALUBIJID',
        BARANGAY: 'TULA',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BALAGNAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BALIWAGAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BINITINAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'BLANCO',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'CALAWAG',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'CAMUAYAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'DANSULI',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'DUMARAIT',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'HERMANO',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'KIBANBAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'LINABU',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'LINGGANGAO',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'MAMBAYAAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'MANDANGOA',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'NAPALIRAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'SAMAY',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'TALUSAN',
    },
    {
        CITY: 'BALINGASAG',
        BARANGAY: 'WATERFALL',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'BAUKBAUK POB. (G.E. ANTONINO)',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'DAHILIG',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'KABANGASAN',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'KABULAKAN',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'LAPINIG (POB.)',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'MANTANGALE',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'MAPUA',
    },
    {
        CITY: 'BALINGOAN',
        BARANGAY: 'SAN ALONZO',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'DAMPIAS',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'KITAMBAN',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'KITAMBIS',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'MOSANGOT',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'NABATAAN',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BINUANGAN',
        BARANGAY: 'VALDECONCHA',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'AGUSAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BAIKINGON',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BALUBAL',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BALULANG',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BALULANG',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 15 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 16 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 17 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 18 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 19 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 20 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 21 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 22 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 23 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 24 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 25 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 26 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 27 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 28 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 29 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 30 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 31 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 32 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 33 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 34 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 35 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 36 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 37 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 38 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 39 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 40 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BAYANGA',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BESIGAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BUGO',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'BULUA',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'CAMAMAN-AN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'CANITO-AN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'CUGMAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'DANSOLIHON',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'F. S. CATANICO',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'GUSA',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'INDAHAG',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'IPONAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'LAPASAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'LUMBIA',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'MACABALAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'MACASANDIG',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'MAMBUAYA',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'PAGALUNGAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'PAGATPAT',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'PIGSAG-AN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'PUERTO',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'PUNTOD',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'SAN SIMON',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'TABLON',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'TAGLIMAO',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'TAGPANGI',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'TIGNAPOLOAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'CAGAYAN-DE-ORO',
        BARANGAY: 'TUMPAGON',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'AMOROS',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'BOLISONG',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'BOLOBOLO',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'CALONGONAN',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'HIMAYA',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'HINIGDAAN',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'KALABAYLABAY',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'KIBONBON',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'MOLUGAN',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'SINALOC',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'EL-SALVADOR',
        BARANGAY: 'ULALIMAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'AGAY-AYAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'ALAGATAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'ANAKAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BAGUBAD',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BAKIDBAKID',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BAL-ASON',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BANTAAWAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 15 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 16 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 17 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 18 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 18-A (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 19 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 20 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 21 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 22 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 22-A (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 23 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 24 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 24-A (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 25 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 26 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'BINAKALAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'CAPITULANGAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'DAAN-LUNGSOD',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'DINAWEHAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'EUREKA',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'HINDANGON',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'KALAGONOY',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'KALIPAY',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'KAMANIKAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'KIANLAGAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'KIBUGING',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'KIPUNTOS',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'LAWIT',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'LIBON',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'LUNAO',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'LUNOTAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MALIBUD',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MARIBUCAO',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MIMBALAGON',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MIMBUNGA',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MIMBUNTONG',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MINSAPINIT',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'MURALLON',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'ODIONGAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'PANGASIHAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'PIGSALUHAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'RICORO',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SAMAY',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SANGALAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'TAGPAKO',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'TALON',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'TINABALAN',
    },
    {
        CITY: 'GINGOOG',
        BARANGAY: 'TINULONGAN',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'BURNAY',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'CARLOS P. GARCIA',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'GREGORIO PELAEZ (LAGUTAY)',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'KILANGIT',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'MATANGAD',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'PANGAYAWAN',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'TALA-O',
    },
    {
        CITY: 'GITAGUM',
        BARANGAY: 'ULAB',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'ALUNA',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'ANDALES',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'APAS',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'CALACAPAN',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'GIMANGPANG',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'JAMPASON',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'KAMELON',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'KANITOAN',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'OGUIS',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'PAGAHAN',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'PONTACON',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'SINALAC',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'TAWANTAWAN',
    },
    {
        CITY: 'INITAO',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'BOBONTUGAN',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'CORRALES',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'I. S. CRUZ',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'JAMPASON',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'KIMAYA',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'LOWER JASAAN (POB.)',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'LUZ BANZON',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'NATUBO',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'SOLANA',
    },
    {
        CITY: 'JASAAN',
        BARANGAY: 'UPPER JASAAN (POB.)',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'BERAY',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'BOLISONG',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'BUKO',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'CALUBO',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'KAGUMAHAN',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'KALITIAN',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'KITOTOK',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'PANABOL',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'SALICAPAWAN',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'SALUBSOB',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'SUAREZ',
    },
    {
        CITY: 'KINOGUITAN',
        BARANGAY: 'SUMALAG',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'BANGLAY',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'DAMPIL',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'GASTON',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'KABULAWAN',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'LUMBO',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'MANAOL',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'TABOK',
    },
    {
        CITY: 'LAGONGLONG',
        BARANGAY: 'UMAGOS',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'AROMAHON',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'GASI',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'KIBAGHOT',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'LAPAD',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'MOOG',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'SINAI',
    },
    {
        CITY: 'LAGUINDINGAN',
        BARANGAY: 'TUBAJON',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'AYA-AYA',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'BETAHON',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'CALANGAHAN',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'KALUKNAYAN',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'LOWER TALACOGON',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LUGAIT',
        BARANGAY: 'UPPER TALACOGON',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'ARGAYOSO',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'BALINTAD',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'CABALANTIAN',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'DIGKILAAN',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'PAGAWAN',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'PANIANGAN',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'PUNTA SILUM',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'TUOD',
    },
    {
        CITY: 'MANTICAO',
        BARANGAY: 'UPPER MALUBOG',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'BULWA',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'CABUG',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'DIG-AGUYAN',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'DUKA',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'GASA',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'MAANAS',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'MANANUM BAG-O',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'MANANUM DAAN',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'PAHINDONG',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'PORTULIN',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'TAMBAGAN',
    },
    {
        CITY: 'MEDINA',
        BARANGAY: 'TUP-ON',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'ANI-E',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'APOSKAHOY',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BULAHAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'GUMAOD',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'HINAPLANAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'KALAWITAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'LANISE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MADAGUING',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MALAGANA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MAT-I',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MINALWANG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PAMBUGAS',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PANAMPAWAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PATROCENIO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PELAEZ (DON GREGORIO PELAEZ)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TAMBOBOAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TIPOLOHON',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'DULONG',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'GIMAYLAN',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'KIMALOK',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'LUBLUBAN',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'RETABLO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'TANGCUB',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'TAYTAYAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'ABUNDA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'ARTADI',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BONIFACIO AQUINO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CABALAWAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CABANTIAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CABUBUHAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CANDIIS',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'DAMAYUHAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'GUMABON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'KIBUNGSOD',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MINDULAO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TAMA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TIBON-TIBON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TINAAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TULANG (CADENA DE AMOR)',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'VILLA FELIPA',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'BALUARTE',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'CASINGLOT',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'GRACIA',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'NATUMOLAN',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TAGOLOAN',
        BARANGAY: 'SUGBONGCOGON',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'DON PEDRO',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'LINANGKAYAN',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'LUBILAN',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'MAPULOG',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'MAPUTI',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'MAT-I',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'TAGBALOGO',
    },
    {
        CITY: 'NAAWAN',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'AWANG',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'BAGOCBOC',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'BARRA',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'CAUYONAN',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'IGPIT',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'LIMONDA',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'LUYONGBONBON',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'MALANANG',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'NANGCAON',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'OPOL',
        BARANGAY: 'TINGALAN',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'ALIPUATON',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'AMPENICAN',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'BUNAL',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'CASULOG',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'DINAGSAAN',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'GUINALABAN',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'ILI-ILIHON',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'INOBULAN',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'MATAMPA',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'MEMBULI',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'SALAGSAG',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'SALAY RIVER I',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'SALAY RIVER II',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'SARAY',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'TINAGAAN',
    },
    {
        CITY: 'SALAY',
        BARANGAY: 'YUNGOD',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'ALICOMOHAN',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'AMPIANGA',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'KAULAYANAN',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'KIDAMPAS',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'KIRAGING',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'MIMBUAHAN',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'SANTA CRUZ (MABINI)',
    },
    {
        CITY: 'SUGBONGCOGON',
        BARANGAY: 'SILAD',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'BUGDANG',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'CALAMCAM',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'CASIBOLE',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'MACOPA',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'MAGKARILA',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'MANDAHILAG',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'MINTABON',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'PANGPANGON',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'PUNTA SANTIAGO',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'PUTING BALAS',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'SIBANTANG',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'SINDANGAN',
    },
    {
        CITY: 'TALISAYAN',
        BARANGAY: 'TAGBOCBOC',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'BALACANAS',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'DAYAWAN',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'KIMAYA',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'VILLANUEVA',
        BARANGAY: 'TAMBOBONG',
    }
];
